import { observable, action } from 'mobx';
import { ajax, Validator as V } from 'hrone-react';
import _ from "lodash";
import mainStore from '../main.store';
import utils from '../../../assets/utils';

class LoginStore extends V.BaseStore {
    @observable
    resetPasswordForm = {
        areaCode: '',
        phoneNum: '',
        verificationCode: '',
        newPassword: '',
    };

    @observable isSendCode = false;
    @observable sendCodeTip = '发送验证码';
    @observable countdown = 60;
    timer: any = null;

    areaCodeOptions = [
        {
            value: '+86',
            label: '+86',
        },
        {
            value: '+12',
            label: '+12',
        },
        {
            value: '+44',
            label: '+44',
        },
        {
            value: '+001',
            label: '+001',
        },
    ];

    @action
    toSendCode = () => {
        if (this.resetPasswordForm.phoneNum) {
            ajax
                .get('/v1/kiosk-web/getVerificationCode', {
                    areaCode: this.resetPasswordForm.areaCode,
                    phoneNum: _.trim(this.resetPasswordForm.phoneNum),
                    templateId: '10103',
                })
                .then(
                    action(() => {
                        this.isSendCode = true;
                        this.timer = setInterval(
                            action(() => {
                                if (this.countdown) {
                                    this.countdown--;
                                }
                                if (!this.countdown) {
                                    clearInterval(this.timer);
                                    this.isSendCode = false;
                                    this.countdown = 60;
                                }
                            }),
                            1000
                        );
                    })
                );
        } else {
            window.$feedback('请输入手机号');
        }
    };

    @action
    clearStore = () => {
        this.timer && clearInterval(this.timer);
        this.isSendCode = false;
        this.countdown = 60;
        this.resetPasswordForm = {
            areaCode: '',
            phoneNum: '',
            verificationCode: '',
            newPassword: '',
        };
    };

    @action
    submit = () => {
        if (!this.validate()) return;
        ajax
            .post('/v1/kiosk-web/login/changePassword', {
                newPassword: utils.encryptByDESModeEBC(_.trim(this.resetPasswordForm.newPassword)),
                areaCode: this.resetPasswordForm.areaCode,
                phoneNum: _.trim(this.resetPasswordForm.phoneNum),
                verificationCode: _.trim(this.resetPasswordForm.verificationCode),
            })
            .then(
                action(() => {
                    this.resetPasswordForm = {
                        areaCode: '',
                        phoneNum: '',
                        verificationCode: '',
                        newPassword: '',
                    };
                    window.$feedback('恭喜您已重置密码，请重新登录', 'success');
                    setTimeout(
                        action(() => {
                            mainStore.isShowResetPassword = false;
                        }),
                        1000
                    );
                })
            );
    };

    @action
    clearValidation = () => {
        this.clearValidationResult();
    };

    getValidationConfig() {
        return {
            'resetPasswordForm.phoneNum': {
                required: true,
                assert: (value: string) => {
                    if (this.resetPasswordForm.areaCode === '+86') {
                        let phone = /^1[345789]\d{9}$/;
                        return phone.test(value);
                    } else {
                        return true;
                    }
                },
                messages: {
                    assert: '请输入正确的手机号',
                },
            },
            'resetPasswordForm.verificationCode': {
                required: true,
            },
            'resetPasswordForm.newPassword': {
                required: true,
                password: true,
            },
        };
    }
}

export default new LoginStore();
